import React from "react";
import { Outlet } from "react-router-dom";

import "../assets/styles/style.css";

import SideNav from "../Pages/Shared/SideNav";

const MainLayout = () => {

 

  return (
    <div  className="main   min-h-screen w-full ">
      <SideNav
    
      />
      <main className="main-content relative min-h-screen w-full md:pl-[280px] lg:pl-[280px]">
        <div className="z-50 relative">
        <Outlet  />
        </div>
        <div>
          <div className="wave_anim ">
            <div className="wave wave1"></div>
            <div className="wave wave2"></div>
            <div className="wave wave3"></div>
            <div className="wave wave4"></div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default MainLayout;
